<template>
  <v-container
    flat
    class="ma-0 pa-0"
  >
    <v-btn-toggle
      v-if="coins"
      v-model="coinIndex"
      mandatory
      group
      class="d-flex justify-center mb-4"
    >
      <v-btn
        v-for="coin in coins"
        :key="coin.name"
        icon
        plain
        x-large
        class="ml-3"
      >
        <v-avatar
          size="50"
        >
          <v-img :src="require(`../../assets/${coin.logo}`)" />
        </v-avatar>
      </v-btn>
    </v-btn-toggle>
    <coin 
      :coin="coin"
      :total-amount="totalAmount"
      :is-ready="isReady"
      :currency-icon="currencyIcon"
    />
  </v-container>
</template>

<script>
import Coin from './Coin'

export default {
  components: {
    Coin,
  },
  props: {
    coins: {
      type: Array,
      default: ()=>{return []}
    },
    totalAmount: {
      type: Number,
      default: ()=>0
    },
    mode: {
      type: String,
      default: ()=>null
    },
    isReady: {
      type: Boolean,
    },
    currencyIcon: {
      type: String,
      default: ()=>null
    }
  },
  data() {
    return {
      coinIndex: null,
    }
  },
  computed: {
    coin(){
      return this.coins[this.coinIndex]
    },
  },
}
</script>